<div class="container-fluid">
  <app-route-card-grid [items]="userManagementItems"></app-route-card-grid>
</div>
